import {View} from 'native-base';
import React from 'react';

import LinearGradient from 'components/LinearGradient';

export interface MirroredGradientPropTypes {
  height?: string;
  width?: string;
  borderRadius?: string;
}

const MirroredGradient: React.FC<MirroredGradientPropTypes> = props => {
  const {height = '22px', width = undefined, borderRadius = undefined} = props;

  return (
    <View
      borderRadius={borderRadius}
      overflow={width ? 'hidden' : undefined}
      width={width}>
      <LinearGradient colors={['#d8d8d8', '#eee']} mirrored rotation="90deg">
        <View width={width} height={height} />
      </LinearGradient>
    </View>
  );
};

export default MirroredGradient;
